module.exports = __webpack_public_path__ + "assets/4f26d092df2ca7421730993b50b1c24a.png";